(ns teamoesterreich.admin-mode.can-you.can-you-overview
  (:require [clojure.string]
            [goog.string.format]
            [reagent-material-ui.components :as mui]
            [reagent.core :as r]
            [teamoesterreich.admin-mode.actions :as a]
            [teamoesterreich.view-state :as vstate]
            [teamoesterreich.admin-mode.data.event :as d-events]
            [teamoesterreich.admin-mode.data.rights :as d-rights]
            [teamoesterreich.util.log :as log]
            [teamoesterreich.view-state :as store]
            [teamoesterreich.admin-mode.can-you.can-you-form :as can-you-form]
            [teamoesterreich.admin-mode.modal.are-you-sure-modal :as are-you-sure-modal]
            [teamoesterreich.admin-mode.component.ws-event-sync-component :as ws-event-sync-component]

            [goog.json :as json]
            [clojure.string :as str]

            [teamoesterreich.admin-mode.can-you.can-you-user-table :as event-user-table]
            [reagent-material-ui.icons.keyboard-arrow-left :refer [keyboard-arrow-left]]
            [reagent-material-ui.icons.keyboard-arrow-right :refer [keyboard-arrow-right]]
            [reagent-material-ui.icons.check :refer [check]]
            [reagent-material-ui.icons.info :refer [info]]
            [reagent-material-ui.icons.delete-outline :refer [delete-outline]]
            [reagent-material-ui.icons.refresh :refer [refresh]]
            ))



(defn get-it []
  (let [!st (r/atom {:tab 0})
        !tab (r/cursor !st [:tab])]
    (fn []
      (let [!event (r/cursor vstate/app-state [:selected-canyou])
            !actual-user (r/cursor store/app-state [:actual-user])
            !show-delete? (r/cursor vstate/app-state [:event-delete])
            !event-detail-loaded? (r/cursor vstate/app-state [:event-detail-loaded])
            !show-start-warn? (r/cursor vstate/app-state [:show-start-warn])
            !show-end-warn? (r/cursor vstate/app-state [:show-end-warn])
            event-timeFrom (:crowdtaskerEvent-timeFrom @!event)
            event-status (or (:crowdtaskerEvent-status @!event) "created")
            event-step (case event-status
                         "created" 0
                         "waitAccept" 1
                         "collecting" 2
                         "finished" 4
                         "closed" 4
                         0)
            ro? (> event-step 3)
            ok? (and (> event-step 1) (< event-step 4))
            table-set-base {:ro?          ro? :set-unknown? ok? :set-accepted? ok? :set-declined? ok? :set-participated? ok? :set-absent? ok? :set-standby? ok?
                            :allow-alarm? ok? :allow-force-alarm? ok? :show-mission-state? ok? :show-response-state? ok? :show-alarm-answer? ok?}
            cnt-responseStatus-fn (fn [status] (count (filter (fn [e] (and (= "undefined" (or (:crowdtaskerEventMember-missionState e) "undefined"))
                                                                           (= status (or (:crowdtaskerEventMember-responseState e)
                                                                                         (if (:crowdtaskerEventMember-alarmedType e) "alarmed" "unknown"))))) (:crowdtaskerEvent-member @!event))))
            cnt-missionStatus-fn (fn [status] (count (filter (fn [e] (= status (or (:crowdtaskerEventMember-missionState e) "undefined"))) (:crowdtaskerEvent-member @!event))))
            ]

        ;(log/debug "Actual event " @!event-detail-loaded? @!event)


        [mui/grid
         {:container false :item true
          :md        12                                     ;medium: 960px
          :xs        12                                     ;extra-small: 0px
          :style     {:marginTop "5px"}
          }

         [mui/button {:startIcon (r/as-element [keyboard-arrow-left]) :variant "outlined" :style {:margin "5px 40px 5px 0"}
                      :onClick   #(swap! vstate/app-state assoc :site :event-list)
                      }
          "Zurück"]

         [mui/button {:startIcon (r/as-element [refresh])
                      :onClick   #(reset! !event-detail-loaded? false)}
          "Neu laden ...."
          ]]

        (if-not @!event-detail-loaded?
          (do
            (if (:crowdtaskerEvent-uuid @!event)
              (d-events/<event-load (:crowdtaskerEvent-uuid @!event)
                                    (fn [response]
                                      (reset! !event response)
                                      (reset! !event-detail-loaded? true)
                                      ))
              (a/set-page :selected-training))
            [mui/grid
             {:container false :item true
              :md        12                                 ;medium: 960px
              :xs        12                                 ;extra-small: 0px
              :style     {:marginTop "5px"}
              }
             [mui/circular-progress {:variant_ "determinate" :color_ "secondary" :size 40 :style {:marginTop "40px"}}]
             [mui/typography {} "Lade Daten ... "]
             ]
            )

          [mui/grid
           {:container false :item true
            :md        12                                   ;medium: 960px
            :xs        12                                   ;extra-small: 0px
            :style     {:marginTop "5px"}
            }
           [mui/card
            [mui/grid {:container true :direction "row" :justify "flex-start" :alignItems "flex-start"}
             [mui/grid {:container false :item true :xs 9}
              [mui/card-header {:title (str "Anfrage " (:crowdtaskerEvent-toeEventId @!event) " ) " (:crowdtaskerEvent-name @!event))
                                :style {:padding "0 0  5px 0"}}
               ]
              ]
             [mui/grid {:container false :item true :xs 3}
              (:crowdtaskerEvent-uuid @!event)
              [ws-event-sync-component/ws-event-reload !event-detail-loaded? :crowdtasker-event (:crowdtaskerEvent-uuid @!event)]
              ]
             ]
            [mui/card-content {}
             [mui/stepper {:active-step event-step}
              [mui/step {
                         :key "Step1"
                         }
               [mui/step-label "Erstellen"]]

              [mui/step {
                         :key "Step2"
                         }
               [mui/step-label "Wartet auf Freischalten"]]

              [mui/step {
                         :key "Step3"
                         }
               [mui/step-label "Aktiv"]]

              [mui/step {
                         :key "Step4"
                         }
               [mui/step-label "Abgeschlossen"]]
              ]]

            [mui/card-content {}
             [are-you-sure-modal/are-you-sure-modal !show-delete? "Nur für Superuser! Anfrage wirklich löschen ?" "löschen"
              (fn [] (d-events/>event-save (:crowdtaskerEvent-uuid @!event) {:crowdtaskerEvent-active false}
                                           (fn [data] (swap! vstate/app-state assoc
                                                             :selected-canyou nil
                                                             :event-detail-loaded false
                                                             :event nil
                                                             :site :event-list
                                                             ))))]

             [are-you-sure-modal/are-you-sure-modal !show-start-warn? "Nur für Superuser! Es ist noch nicht Anfrage Beginn! Willst du ihn trotzdem starten ?" "Trotzdem starten"
              (fn [] (d-events/>event-save (:crowdtaskerEvent-uuid @!event) {:crowdtaskerEvent-status "running"} (fn [data] (reset! !event-detail-loaded? false))))]

             [are-you-sure-modal/are-you-sure-modal !show-end-warn? "Willst du diese Anfrage beenden ? Ergebnisse erscheinen nicht mehr in der Liste" "beenden"
              (fn [] (d-events/>event-save (:crowdtaskerEvent-uuid @!event)
                                           {:crowdtaskerEvent-status "closed"
                                            :crowdtaskerEvent-timeTo (or (:crowdtaskerEvent-timeTo @!event)
                                                                         (let [date (js/Date.)]
                                                                           (goog.string.format "%04d%02d%02dT%02d%02d%02d.000Z" (.getFullYear date) (inc (.getMonth date)) (.getDate date) (.getHours date) (.getMinutes date) (.getSeconds date)) ;20180701T100000.000Z
                                                                           ))
                                            } (fn [data] (reset! !event-detail-loaded? false))))]


             (when (= event-status "created")
               [mui/button {:variant   "outlined" :color "secondary"
                            :disabled  (not (and
                                              ; not needed Franz 20220627  (> (:_crowdtaskerEvent-countMembers @!event) 0)
                                              (> (count (str (:crowdtaskerEvent-timeFrom @!event))) 0)
                                              (> (count (str (:crowdtaskerEvent-name @!event))) 0)
                                              (> (count (str (:crowdtaskerEvent-timeTo @!event))) 0)
                                              ))
                            :startIcon (r/as-element [check])
                            :onClick   (fn [] (d-events/>event-save (:crowdtaskerEvent-uuid @!event) {:crowdtaskerEvent-status "waitAccept"} (fn [data] (reset! !event-detail-loaded? false))))
                            :style     {:marginRight "10px"}}
                "Freischalten beantragen"])


             (when (and (= event-status "waitAccept") (d-rights/allow-admin-for d-rights/CANYOU_ACTIVATE))
               [mui/button {:variant   "outlined" :color "primary"
                            :startIcon (r/as-element [keyboard-arrow-left])
                            :onClick   (fn [] (d-events/>event-save (:crowdtaskerEvent-uuid @!event) {:crowdtaskerEvent-status "created"} (fn [data] (reset! !event-detail-loaded? false))))
                            :style     {:marginRight "10px"}}
                "Ablehnen"])

             (when (and (= event-status "waitAccept") (d-rights/allow-admin-for d-rights/CANYOU_ACTIVATE))
               [mui/button {:variant   "outlined" :color "secondary"
                            :title     "Nur für Superadmin"
                            :startIcon (r/as-element [keyboard-arrow-right])
                            :onClick   (fn [] (d-events/>event-save (:crowdtaskerEvent-uuid @!event) {:crowdtaskerEvent-status "collecting" :crowdtaskerEvent-published true} (fn [data] (reset! !event-detail-loaded? false))))
                            :style     {:marginRight "10px"}}
                "Freischalten"])


             (when (and (= event-status "waitAccept") (not (d-rights/allow-admin-for d-rights/CANYOU_ACTIVATE)))
               [mui/chip {:label "Wartet auf die Freigabe!" :color "#e10032" :icon (r/as-element [info])}])




             (when (= event-status "collecting")
               [mui/button {:variant  "outlined"
                            :onClick  (fn [] (reset! !show-end-warn? true))
                            :color    "secondary"
                            :style    {:marginRight "10px"}}
                "Anfrage abschließen"])

             [:div {:style {:display "inline-block" :width "200px"}}]

             (when (= event-status "created")
               [mui/button {:variant   "outlined" :color "primary"
                            :startIcon (r/as-element [delete-outline])
                            :onClick   #(reset! !show-delete? true)
                            :style     {:marginRight "10px"}}
                "Löschen"])

             (when (= event-status "collecting")
               [mui/button {:variant   "outlined"
                            :onClick   (fn [] (d-events/>event-save (:crowdtaskerEvent-uuid @!event) {:crowdtaskerEvent-status "created" :crowdtaskerEvent-published false} (fn [data] (reset! !event-detail-loaded? false))))
                            :title     "Nur für Superadmin"
                            :startIcon (r/as-element [keyboard-arrow-left])
                            :style     {:marginRight "10px" :color "orange"}}
                "Freischaltung zurücknehmen"])


             (when (= event-status "finished")
               [mui/button {:variant   "outlined"
                            :onClick   (fn [] (d-events/>event-save (:crowdtaskerEvent-uuid @!event) {:crowdtaskerEvent-status "running"} (fn [data] (reset! !event-detail-loaded? false))))
                            :title     "Nur für Superadmin"
                            :startIcon (r/as-element [keyboard-arrow-left])
                            :style     {:marginRight "10px" :color "orange"}}
                "beenden zurücknehmen"])

             ]
            [:span {:style {:color "red"}}
             (str
               (when (< (:_crowdtaskerEvent-countMembers @!event) 1) "Keine Personen eingeladen, ")
               (when (< (count (str (:crowdtaskerEvent-timeFrom @!event))) 5) "Beginn Datum fehlt, ")
               (when (< (count (str (:crowdtaskerEvent-name @!event))) 1) "Name fehlt, ")
               (when (< (count (str (:crowdtaskerEvent-description @!event))) 1) "Anfrage fehlt, ")
               (when (< (count (str (:crowdtaskerEvent-timeTo @!event))) 5) "Ende fehlt, ")
               )]
            [:br]
            [:br]

            [mui/card-content {}
             (log/debug "Open Tab " @!tab)
             [mui/tabs {:value          @!tab
                        :onChange       (fn [x i y] (log/debug "set tab " x i y) (reset! !tab i))
                        :indicatorColor "primary"
                        :textColor      "primary"
                        :variant        "scrollable"
                        }
              [mui/tab {:value 0 :label "Details"}]

              ; creating / isWaiting
              (when true [mui/tab {:value 2 :label (str "Zugeteilt (" (cnt-responseStatus-fn "unknown") ")")}])

              ;collecting  2
              (when (> event-step 1) [mui/tab {:value 3 :label (str "Angefragt (" (cnt-responseStatus-fn "alarmed") ")")}])
              (when (> event-step 1) [mui/tab {:value 5 :label (str "Nein (" (cnt-responseStatus-fn "declined") ")")}])
              (when (> event-step 1) [mui/tab {:value 6 :label (str "Unklar (" (cnt-responseStatus-fn "invalid") ")")}])
              (when (> event-step 1) [mui/tab {:value 4 :label (str "Ja (" (cnt-responseStatus-fn "accepted") ")")}])

              (when (or (= (:tom-id @!actual-user) 1) (= (:tom-id @!actual-user) 53177)) [mui/tab {:value 99 :label (str "RAW für " (:tom-id @!actual-user))}])
              ]
             ;;show-absent? show-standby? show-participated?
             (case @!tab
               0 [can-you-form/get-it !event (not= event-status "created")]
               1 [can-you-form/get-it !event (not= event-status "created")]
               2 [mui/card-content {}
                  [(event-user-table/get-it (:crowdtaskerEvent-member @!event) "unknown" nil (merge table-set-base {:allow-alarm? true :allow-force-alarm? false :set-unknown? true :set-declined? true :set-accepted? true :allow-change? false}))]
                  ]
               3 [mui/card-content {}
                  [(event-user-table/get-it (:crowdtaskerEvent-member @!event) "alarmed" nil (merge table-set-base {:allow-alarm? false :allow-force-alarm? true :set-unknown? false :set-declined? true :set-accepted? true :allow-change? false}))]
                  ]
               5 [mui/card-content {}
                  [(event-user-table/get-it (:crowdtaskerEvent-member @!event) "declined" nil (merge table-set-base {:allow-alarm? false :allow-force-alarm? false :set-unknown? true :set-declined? false :set-accepted? true :allow-change? false}))]
                  ]
               6 [mui/card-content {}
                  [(event-user-table/get-it (:crowdtaskerEvent-member @!event) "invalid" nil (merge table-set-base {:allow-alarm? false :allow-force-alarm? true :set-unknown? false :set-declined? true :set-accepted? true :allow-change? true}))]
                  ]
               4 [mui/card-content {}
                  [(event-user-table/get-it (:crowdtaskerEvent-member @!event) "accepted" nil (merge table-set-base {:allow-alarm? false :allow-force-alarm? false :set-unknown? true :set-declined? true :set-accepted? false :allow-change? false}))]
                  ]


               99 [mui/card-content {}
                   [:p "Übersicht über Anfragen....."]
                   [:pre {:style {:textAlign "left"}} (str/replace (json/serialize (clj->js @!event)) "," ",\n")]]

               )
             ]]
           ])))))


;; allow-response-set? allow-mission-set? allow-alarm? allow-force-alarm? ro? show-mission-state? show-response-state? show-alarm-answer?















